import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import { goBack, push } from 'react-router-redux';
import lodash from 'lodash';

import LoadingComponent from 'common/permissions/components/LoadingComponent';
import {
    clearApplicationHeaderTitle
} from 'common/actions/applicationHeader';

import {
    loadForm,
    unloadFormKey
} from 'forms/actions';
import styles from './FormSelector.scss';
import { documentTypePermissionsSelector } from 'common/permissions/selectors';

const formRequire = require.context('../../entry/', true, /\.js$/);

const FormSelectorLoadingComponent = () => (
    <div data-test-id="loading-component" className={styles.container} data-cy="FormSelector">
        <LoadingComponent />
    </div>
);

const FormComponent = ({ form: Component, location, params, pageTitle, goBack, viewDocumentPermission } ) => (
    <div data-test-id="form-component" className={styles.container} data-cy="FormSelector-FormComponent">
        <Header
            title={pageTitle}
            onBackLinkClick={goBack}
            location={location} />
        <Component
            viewDocumentPermission={viewDocumentPermission}
            location={location}
            params={params} />
    </div>
);

export class FormSelector extends Component {

    constructor(...args) {
        super(...args);
        this.state = { Form: undefined };
    }

    componentDidMount() {
        const { source, id, loadForm } = this.props;
        loadForm(source, id);
    }

    componentWillUnmount() {
        this.props.clearApplicationHeaderTitle();
        this.props.unloadFormKey();
    }

    componentDidUpdate(prevProps) {
        const { formKey } = this.props;
        if (formKey && prevProps.formKey !== formKey) {
            const newFormComponent = formRequire(`./${formKey}.js`).default;
            this.setState({ Form: newFormComponent });
        }
        const { source, id, loadForm } = this.props;
        if (source !== prevProps.source || id !== prevProps.id) {
            this.props.clearApplicationHeaderTitle();
            this.props.unloadFormKey();
            loadForm(source, id);
        }
    }

    onClickBackLink(){
        const { source, push, goBack, location } = this.props;
        const subformroute = lodash.get(location, 'query.subformroute');
        switch (true) {
            case (lodash.isEqual(source, 'task') && lodash.isNil(subformroute)):
                push('/inbox');
                break;
            case isNewViewDocumentTab(location):
                window.close();
                break;
            default:
                goBack();
                break;
        }
    }

    render() {
        const { Form } = this.state;
        const { location, params, pageTitle, viewDocumentPermission } = this.props;
        return Form
            ? <FormComponent
                form={Form}
                location={location}
                params={params}
                pageTitle={pageTitle}
                viewDocumentPermission = {viewDocumentPermission}
                goBack={this.onClickBackLink.bind(this)} />
            : <FormSelectorLoadingComponent />;
    }
}

const isNewViewDocumentTab = (location) => {
    const subformroute = lodash.get(location, 'query.subformroute');
    return (lodash.isEqual(location.action, 'POP') && lodash.isEqual(subformroute, 'viewDocument'));
};

const Header = ({ title, onBackLinkClick, location }) => {
    return (
        <div className={styles.header} data-cy="FormSelector-Header">
            <span className={styles.backLink} onClick={onBackLinkClick} data-cy="FormSelector-onClick">
                { !isNewViewDocumentTab(location) ? '< Back' : '< Close' }
            </span>
            <h2 className={styles.title} data-cy="FormSelector-h2">{ title }</h2>
        </div>
    );
};

FormSelector.propTypes = {
    id: PropTypes.string.isRequired,
    source: PropTypes.oneOf(['process', 'processSummary', 'task', 'event', 'doa']).isRequired
};

export default connect(
    (state, props) => {
        const documentTypeId = lodash.get(state, 'form.sentItem.document.documentType.id', null);
        const viewDocumentPermission = documentTypePermissionsSelector(state, documentTypeId);

        return {
            source: lodash.get(props, 'params.source'),
            id: lodash.get(props, 'params.id'),
            formKey: lodash.get(state, 'form.formKey', null),
            formName: lodash.get(state, 'form.name', null),
            pageTitle: lodash.get(state, 'app.pageTitle', null),
            viewDocumentPermission,
        };
    }, {
        loadForm,
        unloadFormKey,
        clearApplicationHeaderTitle,
        goBack,
        push
    }
)(FormSelector);
